import React from "react";
import { Button, Icon } from "antd";

export default function Refresh({clickAction}){
    return(
        <div id="sideButton">
            <Button 
                type="primary" 
                onClick={() => clickAction()}
                style={{height: 45}}
            >
                <Icon type="reload" style={{fontSize: 25}}/>
            </Button>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/common/RefreshButton.jsx